/* =========================================
   FunkPrint Theme JS — v1
   ========================================= */
(function() {
  'use strict';

  // ---------- Sub-brand tabs (homepage featured designs) ----------
  function initSubBrandTabs() {
    const tabs = document.querySelectorAll('.sub-brand-tabs .tab');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const brand = tab.dataset.brand;
        tabs.forEach(t => t.classList.toggle('is-active', t === tab));
        const grid = document.querySelector('.designs-grid');
        if (!grid) return;
        const cards = grid.querySelectorAll('.product-card');
        cards.forEach(c => {
          if (brand === 'all' || c.dataset.brand === brand) {
            c.style.display = '';
          } else {
            c.style.display = 'none';
          }
        });
      });
    });
  }

  // ---------- Product page option buttons ----------
  function initProductOptions() {
    const groups = document.querySelectorAll('.option-group');
    groups.forEach(group => {
      const buttons = group.querySelectorAll('.option-btn');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          buttons.forEach(b => b.classList.toggle('is-selected', b === btn));
        });
      });
    });
  }

  // ---------- Add to cart (Shopify AJAX) ----------
  async function addToCart(variantId, quantity = 1, properties = {}) {
    try {
      const formData = {
        items: [{ id: variantId, quantity: quantity, properties: properties }]
      };
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (!response.ok) throw new Error('Add to cart failed');
      const result = await response.json();
      await updateCartCount();
      showToast('Added to cart');
      return result;
    } catch (err) {
      console.error('Cart error:', err);
      showToast('Could not add to cart', 'error');
    }
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const count = document.querySelector('.cart-count');
      if (count) count.textContent = cart.item_count;
      window.FunkPrint.cartCount = cart.item_count;
    } catch (err) { console.error(err); }
  }

  // ---------- Toast notifications ----------
  function showToast(message, type = 'success') {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.style.cssText = `
        position: fixed; bottom: 24px; left: 50%;
        transform: translateX(-50%); z-index: 9999;
        padding: 12px 24px; border-radius: 999px;
        background: ${type === 'error' ? '#DC2626' : '#1A1A1A'}; color: white;
        font-size: 14px; font-weight: 600;
        box-shadow: 0 8px 24px rgba(0,0,0,0.2);
        opacity: 0; transition: opacity 0.2s ease;
      `;
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      setTimeout(() => { toast.style.opacity = '0'; }, 2400);
    });
  }

  // ---------- Wire up product page add-to-cart button ----------
  function initProductForm() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      addToCart(variantId);
    });
  }

  // ---------- Path card click handlers ----------
  function initPathCards() {
    document.querySelectorAll('.path-card').forEach(card => {
      const link = card.dataset.href;
      if (link) {
        card.addEventListener('click', () => { window.location.href = link; });
      }
    });
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    initSubBrandTabs();
    initProductOptions();
    initProductForm();
    initPathCards();
    updateCartCount();
  });

  // Expose for design studio
  window.FunkPrintCart = { addToCart, updateCartCount, showToast };
})();
